'use client';
var classes = {"root":"m_18320242","skeleton-fade":"m_299c329c"};

export { classes as default };
//# sourceMappingURL=Skeleton.module.css.mjs.map
